"use strict";

/**
 * @classdesc
 * Zeigt an, dass eine Annahme nicht erfüllt ist.
 *
 * @class
 * @extends gc.gis.error.GCError
 * @memberof gc.gis.error
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {string} message Beschreibung des Fehlers
 * @param {Error} [opt_cause] Optionale Ursache dieses Fehlers
 */
gc.gis.error.GCAssertionError = function(message, opt_cause )
{
	gc.gis.error.GCError.call( this, message, opt_cause );

	this.name    = 'gc.gis.error.GCAssertionError';
	this.message = 'Assertion failed' + ( message ? ': '+ message : '');
};
gc.gis.error.GCAssertionError.prototype = Object.create( gc.gis.error.GCError.prototype );

